import { useSymbolsStore } from '../store/Symbols';
import { useSymbolsRender } from '../utils/useRender';
export var BracketsLeft = props => {
  var {
    BracketsLeft: Comp = {}
  } = useSymbolsStore();
  useSymbolsRender(Comp, props, 'BracketsLeft');
  return null;
};
BracketsLeft.displayName = 'JVR.BracketsLeft';